import React, { useCallback, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { toast } from 'react-toastify';

const ContactProfileInfoItem = ({ icon, label, data, loading, phoneNumber }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = useCallback(() => {
        if (!data) return;

        navigator.clipboard.writeText(data).then(() => {
            setCopied(true);
            toast.success('با موفقیت کپی شد');
            setTimeout(() => setCopied(false), 2000);
        });
    }, [data]);

    return (
        <div className="flex items-center gap-4">
            <ReactSVG 
                src={`${process.env.PUBLIC_URL}/assets/images/icons/${icon}.svg`}
                className="w-6 text-primary"
            />

            <div className="flex items-start flex-col gap-1">
                <span className="text-gray-500 text-sm">{label}</span>

                {loading ? (
                    <div className="h-6 flex items-center">
                        <ReactSVG 
                            src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`}
                            className="w-7 text-gray-600"
                        />
                    </div>
                ) : (
                    <div 
                        onClick={phoneNumber ? handleCopy : undefined}
                        className={`group flex items-center gap-2 transition-colors ${data ? 'cursor-pointer hover:text-primary' : ''}`}
                    >
                        {data ? (
                            <span dir="ltr">
                                {phoneNumber && data.length >= 10 ? (
                                    <>
                                        <span>{data.slice(0, 4)}</span>
                                        <span className="px-0.5">{data.slice(4, 7)}</span>
                                        <span>{data.slice(7)}</span>
                                    </>
                                ) : (
                                    data
                                )}
                            </span>
                        ) : (
                            <span>-</span>
                        )}

                        {data && phoneNumber && (
                            <span>
                                {copied ? (
                                    <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                                ) : (
                                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" /></svg>
                                )}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactProfileInfoItem;